import { Trans, useLingui } from '@lingui/react/macro'

import { H2 } from '../../_components/H2'
import { PrimaryButton } from '../../_components/PrimaryButton'

import { aiThinkingImages, getLocalizedIndexImage } from './localizedImages'

import LazyImage from '@/components/LazyImage'
import { useLocale } from '@/hooks/routes'

export const AiThinking: React.FC = () => {
  const { t } = useLingui()
  const locale = useLocale()
  const src = getLocalizedIndexImage(
    locale,
    '/images/index/ai-reasioning-thinking.png?t=1',
    aiThinkingImages,
  )

  return (
    <div className='relative z-[1] mx-auto max-w-screen-lg px-4 text-center'>
      <H2 className='pt-3 md:pt-6'>
        <Trans>Craft Professional Lyrics with Deep Reasoning Models</Trans>
      </H2>
      <p className='text-f-other-10 pt-2 text-sm md:pt-3 md:text-xl'>
        <Trans>
          Writer’s block? Meet your AI lyrics generator. Our deep reasoning
          models generate verses, choruses and bridges that perfectly match your
          prompts and convey your ideas better.
        </Trans>
      </p>
      <LazyImage
        width={1024}
        height={386}
        src={src}
        alt={t`Craft Lyrics with Deep Reasoning Models`}
        className='mx-auto mt-6 md:mt-12'
      />
      <PrimaryButton
        href='/ai-music-generator'
        className='mx-auto mt-6 md:mt-12'
      >
        <Trans>Try Free AI Music Generator</Trans>
      </PrimaryButton>
    </div>
  )
}
